import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import { fetchSiteTraitsResource } from '@atlassian/jira-router-resources-recommendations/src/services/fetch-site-traits/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import type { PersonalizationApiTraitData } from '@atlassian/jira-router-resources-recommendations/src/services/fetch-site-traits/types.tsx';

export const jiraTrait = 'jsw_ccp_auto_upgraded_trialing_and_predunning_sites';
export const jsmTrait = 'jsm_ccp_auto_upgraded_trialing_and_predunning_sites';
export const jpdTrait = 'jpd_ccp_auto_upgraded_trialing_and_predunning_sites';

const getProductSpecificTrait = (
	siteTraitsData: PersonalizationApiTraitData[] | null,
	productType: ProjectType | undefined,
) => {
	return siteTraitsData && productType
		? siteTraitsData.find((trait) => {
				if (!trait) return;

				switch (productType) {
					case 'software':
						return trait.name === jiraTrait;
					case 'service_desk':
						return trait.name === jsmTrait;
					case 'product_discovery':
						return trait.name === jpdTrait;
					default:
						return false;
				}
			})
		: undefined;
};

export const useAutoUpgradeTrait = ({ projectType }: { projectType: ProjectType | undefined }) => {
	const {
		data: siteTraitsData,
		loading,
		error,
	} = useResource<PersonalizationApiTraitData[] | null>(fetchSiteTraitsResource);

	const productTrait = getProductSpecificTrait(siteTraitsData, projectType);

	return {
		data: productTrait,
		loading,
		error,
	};
};
